type FaviconPath = `/favicon${"-local" | "-staging" | ""}.${"ico" | "png"}`

const getFaviconPath = (): FaviconPath => {
  const env = process.env.NEXT_PUBLIC_ENV || "local"

  let faviconPath: FaviconPath
  switch (env) {
    case "local": {
      faviconPath = "/favicon-local.png"
      break
    }
    case "feature":
    case "staging": {
      faviconPath = "/favicon-staging.png"
      break
    }
    default: {
      faviconPath = "/favicon.ico"
    }
  }

  return faviconPath
}

export { getFaviconPath, type FaviconPath }
